import { Link } from '@remix-run/react'
import React from 'react'

function UnderLineLink({to, children}) {
  return (
    <Link to={to} className={`font-light border-b-2 border-gray-300 hover:border-green transition-all`}>{children}</Link>
  )
}

export default UnderLineLink